const applicationServerKey = 'BFZr2av0/OQazm4rxCUx2hmMNx/neS4mPXqQovxxrqIfIrISfLfbl1Pwlm2rfyx/IJs7qQm8sT20RWJBFdlXJT4';
const LSKEY = 'fob_subscribed';
const LSKEYDONOTASK = 'fob_subscribed_do_not_ask';

function urlBase64ToUint8Array(base64String) {
	const padding = '='.repeat((4 - base64String.length % 4) % 4);
	// eslint-disable-next-line
	const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}

	return outputArray;
}

/**
 * checks if Push notification and service workers are supported by your browser
 */
function isPushNotificationSupported() {
	return 'serviceWorker' in navigator && 'PushManager' in window;
}

/**
 * asks user consent to receive push notifications and returns the response of the user, one of granted, default, denied
 */
async function askUserPermission() {
	return await Notification.requestPermission();
}

/**
 *
 * using the registered service worker creates a push notification subscription and returns it
 *
 */
async function createNotificationSubscription() {
	//wait for service worker installation to be ready
	const serviceWorker = await navigator.serviceWorker.ready;
	// subscribe and return the subscription
	return await serviceWorker.pushManager.subscribe({
		userVisibleOnly: true,
		applicationServerKey: urlBase64ToUint8Array(applicationServerKey)
	});
}

/**
 * returns the subscription if present or nothing
 */
function getUserSubscription() {
	//wait for service worker installation to be ready, and then
	return navigator.serviceWorker.ready
		.then(function (serviceWorker) {
			return serviceWorker.pushManager.getSubscription();
		})
		.then(function (pushSubscription) {
			return pushSubscription;
		});
}

/**
 * returns the subscription at local storage using LSKEY (Logar)
 */
function isSubscribed(userLogin) {
	if (window.localStorage.getItem(`${LSKEY}_${userLogin}`) != null) {
		var data = JSON.parse(window.localStorage.getItem(`${LSKEY}_${userLogin}`));
		if (data === null) {
			return false;
		}
		try {
			return !isNaN(data.id);
		} catch (e) {
			return false;
		}
	}
	return false;
}

/**
 * Based on local storage data check if the modal of subscription should vbe opened (Logar)
 */
function should_ask_notifications_permission(userLogin) {
	return (
		window.localStorage.getItem(`${LSKEYDONOTASK}_${userLogin}`) === undefined ||
		window.localStorage.getItem(`${LSKEYDONOTASK}_${userLogin}`) === null ||
		window.localStorage.getItem(`${LSKEYDONOTASK}_${userLogin}`) === false
	);
}

async function unsubscribeNotification() {
	const subscription = await getUserSubscription();
	if (subscription) {
		return await subscription.unsubscribe();
	}
	return;
}

function updateLocalStorage(resp, login) {
	window.localStorage.setItem(`${LSKEY}_${login}`, JSON.stringify(resp));
}

function updateLocalStorageDoNotAsk(login) {
	window.localStorage.setItem(`${LSKEYDONOTASK}_${login}`, '1');
}

export {
	isPushNotificationSupported,
	askUserPermission,
	createNotificationSubscription,
	getUserSubscription,
	isSubscribed,
	should_ask_notifications_permission,
	unsubscribeNotification,
	updateLocalStorage,
	updateLocalStorageDoNotAsk
};
